import { View, type ViewStyle } from 'react-native';
import { Text, useTheme } from 'react-native-paper';

import { spacing } from '@/theme';

interface ErrorStateProps {
  readonly message: string;
  readonly testID?: string;
}

const style: ViewStyle = {
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  padding: spacing[6],
};

export const ErrorState = ({ message, testID }: ErrorStateProps) => {
  const theme = useTheme();

  return (
    <View style={style} testID={testID}>
      <Text style={{ color: theme.colors.error }}>{message}</Text>
    </View>
  );
};
